import { render, staticRenderFns } from "./notificationBarButton.vue?vue&type=template&id=056de185&"
import script from "./notificationBarButton.vue?vue&type=script&lang=js&"
export * from "./notificationBarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports